import { render, staticRenderFns } from "./AffiliateEditor.vue?vue&type=template&id=fde38930&scoped=true"
import script from "./AffiliateEditor.vue?vue&type=script&lang=js"
export * from "./AffiliateEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fde38930",
  null
  
)

export default component.exports